import { render } from "./UserReviewsComponent.vue?vue&type=template&id=44058f81&scoped=true"
import script from "./UserReviewsComponent.vue?vue&type=script&lang=js"
export * from "./UserReviewsComponent.vue?vue&type=script&lang=js"

import "./UserReviewsComponent.vue?vue&type=style&index=0&id=44058f81&scoped=true&lang=css"

import exportComponent from "C:\\Users\\epentilescu\\source\\repos\\Delicitate V2\\front-end\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44058f81"]])

export default __exports__